import { useEffect, useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Box,
  useTheme,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import axios from "axios";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import config from "../../../../config";

//project components
import FollowupForm from "./FollowupForm";
import { useSelector } from "react-redux";
import {
  convertDateToLocal,
  convertDateToLocalReverse,
} from "../../../../utils/date-operations";

const Followup = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const theme = useTheme();
  const { followups, onSave, candidateId } = props;
  const { userId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  //States
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedFollowup, setSelectedFollowup] = useState({
    id: 0,
    candidateId: candidateId,
    followUpDate: convertDateToLocalReverse(new Date()),
    nextFollowUpDate: convertDateToLocalReverse(new Date()),
    comments: "",
    followUpBy: userId,
  });

  const handleAdd = () => {
    setSelectedFollowup({
      id: 0,
      candidateId: candidateId,
      followUpDate: convertDateToLocalReverse(new Date()),
      nextFollowUpDate: convertDateToLocalReverse(new Date()),
      comments: "",
      followUpBy: userId,
    });
    setOpenAdd(true);
  };
  //Methods
  const handleDelete = () => {
    axiosAuth
      .delete("/api/CandidateFollowUps/" + selectedFollowup.id)
      .then((response) => {
        onSave();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
      });
  };
  const handleSave = () => {
    onSave();
    setOpenAdd(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
  };
  const handleCancelDelete = () => {
    setOpenDelete(false);
  };

  return (
    <Card elevation={3}>
      <Grid
        sx={{
          // background:
          //   "linear-gradient(to right,#4a7dcf 0%,rgba(15, 217, 224, 0.73) 100%)",
          backgroundColor: theme.palette.warning.light,
          paddingX: 2,
          paddingY: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
              }}
            >
              Candidate Followups
            </Typography>
          </Grid>
          {role !== 4 && (
            <Grid item>
              <IconButton onClick={handleAdd}>
                <AddIcon sx={{ color: "#ffffff" }} />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
          }}
        >
          {followups && followups?.length > 0 ? (
            followups?.map((followup, index) => {
              return (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    margin: 1,
                    paddingX: 1,
                    paddingY: 2,
                    // display: "flex",
                    // justifyContent: "space-between",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <Stack spacing={1}>
                    {/* <Typography>
                    <b>Candidate Name:</b> {followup.candidateName}
                  </Typography> */}
                    <Typography>
                      <b>Followup Date:</b>{" "}
                      {convertDateToLocal(followup.followUpDate)}
                    </Typography>

                    <Typography>
                      <b>Followup By:</b> {followup.followUpByName}
                    </Typography>
                    <Typography>
                      <b>Next Followup By:</b>{" "}
                      {convertDateToLocal(followup.nextFollowUpDate)}
                    </Typography>
                    <Typography>
                      <b>Comments:</b> {followup.comments}
                    </Typography>
                  </Stack>
                  {role !== 4 && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Stack
                        // alignItems="center"
                        // justifyContent="center"
                        // spacing={2}
                        direction="row"
                      >
                        <IconButton
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            setSelectedFollowup(followup);
                            setOpenAdd(true);
                          }}
                        >
                          <EditIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => {
                            setSelectedFollowup(followup);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteIcon fontSize="inherit" />
                        </IconButton>
                      </Stack>
                    </>
                  )}
                </Card>
              );
            })
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No followup data available
              </Typography>
            </Box>
            // <NoDataFound />
          )}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          {followups && followups?.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 40 }}>#</TableCell>
                    {/* <TableCell align="left" sx={{ width: 200 }}>
                    Candidate Name
                  </TableCell> */}
                    <TableCell align="left" sx={{ width: 120 }}>
                      Followup Date
                    </TableCell>
                    <TableCell align="left" sx={{ width: 150 }}>
                      Followup By
                    </TableCell>
                    <TableCell align="left" sx={{ width: 150 }}>
                      Next Followup Date
                    </TableCell>
                    <TableCell align="left">Comments</TableCell>
                    <TableCell align="right" sx={{ width: 90 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {followups.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      {/* <TableCell align="left">{row.candidateName}</TableCell> */}
                      <TableCell align="left">
                        {convertDateToLocal(row.followUpDate)}
                      </TableCell>

                      <TableCell align="left">{row.followUpByName}</TableCell>
                      <TableCell align="left">
                        {convertDateToLocal(row.nextFollowUpDate)}
                      </TableCell>
                      <TableCell align="left">{row.comments}</TableCell>
                      <TableCell align="right">
                        {role !== 4 && (
                          <>
                            <IconButton
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedFollowup(row);
                                setOpenAdd(true);
                              }}
                            >
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => {
                                setSelectedFollowup(row);
                                setOpenDelete(true);
                              }}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No followup data available
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>

      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <FollowupForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedFollowup={selectedFollowup}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Followup</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the followup of{" "}
            <span style={{ color: "#E90000" }}>
              {selectedFollowup.candidateName}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default Followup;
